<template>
  <div class="view-training">
    <BannerCarousel section-type="training" scroll-target-id="cards" />
    <CardsGrid :page-id="pageId" variant="training" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BannerCarousel from '@/components/common/banner-carousel.vue';
import CardsGrid from '@/components/common/cards-grid.vue';
import { PageEnum } from '@/models/page.enum';
import { BannersService } from '@/services/banners.service';
import { useLocale } from '@/composables/locale';

export default defineComponent({
  components: {
    BannerCarousel,
    CardsGrid,
  },
  setup() {
    const { userLanguage } = useLocale();

    return { userLanguage };
  },
  data() {
    return {
      pageId: PageEnum.training,
      bannersService: new BannersService(),
      bannerMainImageProps: {
        backgroundImageUrl: '',
        title: '',
        subtitle: '',
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const bannerSections = await this.bannersService.getBannerSections();
      const marketingSection = bannerSections.model?.find((bannerSection) => bannerSection.type === 'training');

      if (marketingSection) {
        const banner = await this.bannersService.getBanners(marketingSection.externalId, this.userLanguage);
        const bannerModel = banner?.model?.find((m) => m.externalId === '5zRpUpx8eoPnOHmC3QklsM');

        if (!bannerModel) {
          return;
        }

        this.bannerMainImageProps.backgroundImageUrl = bannerModel.imageUrl;
        this.bannerMainImageProps.title = bannerModel.title[this.userLanguage];
        this.bannerMainImageProps.subtitle = bannerModel.subtitle[this.userLanguage];
      }
    },
  },
});
</script>
